import { Link } from "react-router-dom";
import { TX } from "../../lib/texte";

/**
 * Bildmarke plus Wortmarke.
 *
 * `logo.svg` ist die LILASp-Wortmarke aus webgis, unverändert übernommen
 * (B5) — sie trägt den Namen „LILASp" als Pfade (#706f6f) mit dem Petrol-Punkt
 * (#045863). Das Produktwort daneben ist ein eigenes Element, damit es der
 * Schrift und dem Thema folgen kann; gesetzt ist es wie `.brand span` des
 * Prototyps und der Artboards: 11 px, gesperrt, Versalien, gedämpft
 * (`.marke span` in app.css).
 *
 * `--logo-filter` hellt die graue Marke im dunklen Thema auf; ohne ihn
 * versinkt sie im Grund. Auf dem Telefon blendet app.css das Produktwort IN
 * DER KOPFLEISTE aus (`.kopf .marke span` unter 640 px) — der Platz gehört
 * dort den Werkzeugen; am Schreibtisch und auf der Anmeldeseite bleibt es.
 */
export function Logo() {
  return (
    <Link to="/" className="marke ring-focus" aria-label={`${TX.marke.name} ${TX.marke.produkt}, zur Planliste`}>
      <img src="/logo.svg" alt={TX.marke.name} width={72} height={20} />
      <span aria-hidden>{TX.marke.produkt}</span>
    </Link>
  );
}
